import React, { useEffect, useState, useRef } from "react";
import { LuPlus } from "react-icons/lu";
import "../../../../src/TextFamily.css";
import "../DeshBoard.css";
import { Col, Row, Form, Button, Dropdown } from "react-bootstrap";
import DocumentUpload from "./DocumentUpload";
import SubStepsIcons from "../../../assests/BankStatement.png";
import bankImg from "../../../assests/bankImg.png";
import ChequeImg from "../../../assests/Cheque.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { IoCheckmarkCircle } from "react-icons/io5";
import { Api } from "../../../services/httpService";
import { url, subscriptionKey } from "../../../constants";
import Loader from "../Loader";
import LoaderModal from "../LoaderModal";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import currencyCodes from "currency-codes";
import ReactCountryFlag from "react-country-flag";
import Swal from "sweetalert2";

function BankAccountsList({
  accountList,
  setBankOverview,
  bankOverview,
  addDetails,
  setAddDetails,
  loading,
  setBankAccountId,
  bankAccountId,
  merchantId,
  companyId,
  fetchData,
}) {
  const [showEditModal, setShowEditModal] = useState(false);
  const initialFormState = {
    accountNum: "",
    ibanNum: "",
    bankName: "",
    branchName: "",
    swiftCode: "",
    isPrimary: false,
    currency: "",
    banksId: ""
  };
  const [bankAccount, setBankAccount] = useState();
  const [editFormData, setEditFormData] = useState(initialFormState);
  const [editErrors, setEditErrors] = useState({});
  const [editTouched, setEditTouched] = useState({});
  const [editAllValid, setEditAllValid] = useState(false);
  const [editLoadingModal, setEditLoadingModal] = useState(false);

  const [bankList, setBankList] = useState([]);
  const [documentModal, setDocumentModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFilesMap, setUploadedFilesMap] = useState({});
  const [chequeUploadSuccess, setChequeUploadSuccess] = useState(false);
  const [bankStatementUploadSuccess, setBankStatementUploadSucess] =
    useState(false);
  const [type, setType] = useState("");
  const [entityId, setEntityId] = useState(companyId);
  const [bankLoading, setBankLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState({
    bankStatement: false,
    cancelledCheque: false,
  });
  const bankAccountIdRef = useRef(bankAccountId);

  useEffect(() => {
    bankAccountIdRef.current = bankAccountId;
  }, [bankAccountId]);
  useEffect(() => {
    if (bankAccountId) {
      let bankAccount = accountList.filter((account) => {
        return account.id === bankAccountId;
      })[0];

      setEditFormData({
        accountNum: bankAccount.accountNum || "",
        ibanNum: bankAccount.ibanNum || "",
        bankName: bankAccount.bankName || "",
        branchName: bankAccount.branchName || "",
        swiftCode: bankAccount.swiftCode || "",
        currency: bankAccount.currency,
        isPrimary: bankAccount.isPrimary,
        banksId: bankAccount.banksId || ""
      });
    }
  }, [bankAccountId]);

  useEffect(() => {
    const fetchBanksList = async () => {
      try {
        const response = await Api("get", `/bank/getBankNamesList`);
        if (response && response.body) {
          // setBankList(response.body?.map((bank) => bank.bankName));
          setBankList(response.body || []);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchBanksList();
  }, [companyId]);

  // const sortedCurrencies = [...currencyCodes.data].sort((a, b) => {
  //   if (a.code === "USD") return -1;
  //   if (b.code === "USD") return 1;
  //   return 0;
  // });

  const sortedCurrencies = [...currencyCodes.data].sort((a, b) => {
    if (a.code === "AED") return -1;
    if (b.code === "AED") return 1;

    if (a.code === "USD") return -1;
    if (b.code === "USD") return 1;

    return a.code.localeCompare(b.code); // sort remaining alphabetically
  });

  const currencyOptions = sortedCurrencies.map((currency) => ({
    value: currency.code,
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <ReactCountryFlag
          countryCode={currency.code.slice(0, 2)}
          svg
          style={{ width: "1.5em", marginRight: "10px" }}
        />
        {currency.code} — {currency.currency}
      </div>
    ),
  }));

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "12px",
      minHeight: "55px",
      borderColor: state.isFocused ? "#acacc2" : "#f9f9fa",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(196, 196, 202, 0.2)"
        : "none",
      paddingLeft: "35px",
      // Placeholder ko center karne ke liye
      display: "flex",
      alignItems: "center",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#94a3b8",
      // Center alignment ke liye
      margin: 0,
      padding: 0,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "calc(100% - 40px)", // paddingLeft adjust karne ke liye
    }),
    dropdownIndicator: (base) => ({
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0",
      display: "flex",
      alignItems: "center",
      position: "relative",
      height: "100%",
    }),
    singleValue: (base) => ({
      ...base,
      margin: 0,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    }),
  };

  const fetchBankDetail = async () => {
    const bankId = bankAccountIdRef.current;
    if (!bankId || bankId === "null") {
      return;
    }
    setBankLoading(true);
    try {
      const response = await Api("get", `/bank/getBankById/${bankId}`);
      const docs = response.body?.documents || [];
      // Separate documents by type
      const bankStatementDocs = docs
        .filter((doc) => doc.documentInfoId === 5)
        .map((doc) => ({
          ...doc,
          isServerFile: true,
          docId: doc.docId,
          url: doc.url,
          fileType: doc.fileType,
          name: doc.fileName,
          date: doc.docIssueDate || "",
          isPasswordProtected: doc.isPasswordProtected,
        }));
      const cancelledChequeDocs = docs
        .filter((doc) => doc.documentInfoId === 10)
        .map((doc) => ({
          ...doc,
          isServerFile: true,
          docId: doc.docId,
          url: doc.url,
          fileType: doc.fileType,
          name: doc.fileName,
          date: doc.docIssueDate || "",
        }));

      setUploadStatus({
        bankStatement: bankStatementDocs.length > 0,
        cancelledCheque: cancelledChequeDocs.length > 0,
      });

      setUploadedFilesMap((prev) => ({
        ...prev,
        [`${bankAccountId}_bankStatement`]: bankStatementDocs,
        [`${bankAccountId}_cancelledCheque`]: cancelledChequeDocs,
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setBankLoading(false);
    }
  };

  useEffect(() => {
    setBankLoading(false);
  }, [bankOverview]);

  useEffect(() => {
    if (bankAccountId) {
      fetchBankDetail();
    }
  }, []);

  // Edit Modal Handlers
  const handleEditBankClick = (account) => {
    setEditFormData({
      accountNum: account.accountNum || "",
      ibanNum: account.ibanNum || "",
      bankName: account.bankName || "",
      branchName: account.branchName || "",
      swiftCode: account.swiftCode || "",
      currency: account.currency,
      isPrimary: account.isPrimary,
    });
    setBankAccountId(account.id);
    // setShowEditModal(true);
    setBankOverview(true);
    setEditTouched({});
    setEditErrors({});
  };


const handleEditChange = (e) => {
  const { name, value, type, checked } = e.target;

  // If checkbox is being checked → show confirmation
  if (type === "checkbox" && checked === true) {
    Swal.fire({
      title: "Are you sure?",
      text: "This will replace the previously selected primary account for this company.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, make primary",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setEditFormData((prev) => ({
          ...prev,
          [name]: true,
        }));

        setEditTouched((prev) => ({ ...prev, [name]: true }));
      }
    });

    return; // stop normal execution
  }

  // Normal behavior (for unchecking or other fields)
  setEditFormData((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));

  setEditTouched((prev) => ({ ...prev, [name]: true }));
};

  useEffect(() => {
    const isValid = validate(editFormData, setEditErrors);
    setEditAllValid(
      editFormData.accountNum.trim() &&
        editFormData.ibanNum.trim() &&
        editFormData.bankName.trim() &&
        editFormData.branchName.trim() &&
        editFormData.swiftCode.trim() &&
        isValid,
    );
  }, [editFormData]);

  const validate = (data, setErrorsFn) => {
    const newErrors = {};
    if (!/^\d{6,16}$/.test(data.accountNum)) {
      newErrors.accountNum = "Account number must be 6-16 digits";
    }
    if (!/^AE\d{21}$/.test(data.ibanNum.toUpperCase())) {
      newErrors.ibanNum =
        "IBAN must be exactly 23 characters, start with 'AE' and followed by 21 digits";
    }
    if (!data.bankName.trim()) {
      newErrors.bankName = "Bank name is required";
    }
    if (!/^[A-Z0-9]{8,11}$/.test(data.swiftCode.toUpperCase())) {
      newErrors.swiftCode =
        "SWIFT code must be 8-11 uppercase letters or numbers";
    }
    setErrorsFn(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setEditTouched({
      accountNum: true,
      ibanNum: true,
      bankName: true,
      branchName: true,
      swiftCode: true,
    });
    if (!validate(editFormData, setEditErrors)) return;
    setEditLoadingModal(true);
    const payload = {
      id: bankAccountId,
      userId: localStorage.getItem("_id"),
      accountNum: editFormData.accountNum,
      ibanNum: editFormData.ibanNum.toUpperCase(),
      bankName: editFormData.bankName,
      branchName: editFormData.branchName.trim(),
      swiftCode: editFormData.swiftCode.toUpperCase(),
      currency: editFormData.currency,
      isPrimary: editFormData.isPrimary,
      companyId: companyId,
      bankStatus: "SUBMITTED",
      banksId: editFormData.banksId
    };

    try {
      const response = await Api("post", `/bank/createOrUpdateBank`, payload);
      if (response.success && response.body) {
        await fetchData();
        await fetchBankDetail();
      }

      if (!response.body) {
        setEditLoadingModal(false);
        alert(response.message);
      }
      if (response.body) {
        setEditFormData({
          accountNum: response.body.accountNum,
          ibanNum: response.body.ibanNum,
          bankName: response.body.bankName,
          branchName: response.body.branchName,
          swiftCode: response.body.swiftCode,
          currency: response.body.currency,
          isPrimary: response.body.isPrimary,
        });
      }
      setShowEditModal(false);
    } catch (err) {
      setEditLoadingModal(false);
      console.log(err);
    }
  };

  // Document Upload Handlers
  const getUploadedFiles = (companyId, docType) =>
    uploadedFilesMap[`${companyId}_${docType}`] || [];

  const setUploadedFilesFor = (companyId, docType, files) => {
    setUploadedFilesMap((prev) => ({
      ...prev,
      [`${companyId}_${docType}`]: files,
    }));
  };

  const handleRemoveFile = async (file, docType) => {
    if (!file.isServerFile) {
      setUploadedFilesFor(
        bankAccountId,
        docType,
        (getUploadedFiles(bankAccountId, docType) || []).filter(
          (f) => f !== file,
        ),
      );
      return;
    }
    const { docId } = file;
    setEditLoadingModal(true);
    try {
      const resDeletedFile = await fetch(
        `${url}/documents/deleteBankDocument/${Number(docId)}`,
        {
          method: "DELETE",
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            Authorization: localStorage.getItem("_token") || "",
          },
          redirect: "follow",
        },
      );
      if (resDeletedFile.ok) {
        setUploadedFilesFor(
          bankAccountId,
          docType,
          (getUploadedFiles(bankAccountId, docType) || []).filter(
            (f) => f.docId !== docId,
          ),
        );
        const docs = (getUploadedFiles(bankAccountId, docType) || []).filter(
          (f) => f.docId !== docId,
        );
        setUploadStatus((prev) => ({
          ...prev,
          [docType]: docs.length > 0,
        }));
      }
      setEditLoadingModal(false);
    } catch (error) {
      setEditLoadingModal(false);
      console.error(error);
    }
  };
  const preventEdgeSpace = (e) => {
    if (e.key === " ") {
      const { selectionStart, value } = e.target;
      // Prevent space at start
      if (selectionStart === 0) {
        e.preventDefault();
      }
      // Prevent double space before or after caret
      if (value[selectionStart - 1] === " " || value[selectionStart] === " ") {
        e.preventDefault();
      }
      // Prevent more than one space at the end
      if (selectionStart === value.length && value.endsWith(" ")) {
        e.preventDefault();
      }
    }
  };
  const preventInvalidSpace = (e) => {
    if (e.key === " ") {
      const { selectionStart, value } = e.target;
      // Prevent space at start or end
      if (selectionStart === 0 || selectionStart === value.length) {
        e.preventDefault();
      }
      // Prevent double space before or after caret
      if (value[selectionStart - 1] === " " || value[selectionStart] === " ") {
        e.preventDefault();
      }
    }
  };
  const preventAccNum = (e) => {
    const isDigit = /^\d$/.test(e.key);

    // Block all non-digit keys (allow some special keys like backspace, arrow keys)
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Delete",
    ];

    if (!isDigit && !allowedKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }

    // If it's a digit and input already has 16 digits, prevent further input
    if (isDigit) {
      const { value } = e.target;
      if (value.length >= 16) e.preventDefault();
    }
  };
  const preventIBAN = (e) => {
    if (/^\d$/.test(e.key)) {
      const { value } = e.target;
      if (value.length >= 23) e.preventDefault();
    }
  };
  const preventSwiftCode = (e) => {
    const { value } = e.target;
    // Block input if length is already 11 and user tries to type more
    if (
      value.length >= 11 &&
      e.key.length === 1 &&
      !e.ctrlKey &&
      !e.metaKey &&
      !e.altKey
    ) {
      e.preventDefault();
      return;
    }
    // Prevent space at start or end
    if (e.key === " ") {
      const { selectionStart } = e.target;
      if (selectionStart === 0 || selectionStart === value.length) {
        e.preventDefault();
      }
    }
  };
  const guidelinesContentBank = (
    <div className="guideline-sec">
      <h2>Guidelines</h2>
      <ul>
        <li className="mb-2">
          Upload the consolidated bank statement covering the last 6 months.
        </li>
        <li className="mb-2">
          Supported format: PDF only (max 50MB per file).
        </li>
      </ul>
    </div>
  );

  const guidelinesContentCheque = (
    <div className="guideline-sec">
      <h2>Guidelines</h2>
      <ul>
        <li className="mb-2">Upload photo or scan of your document.</li>
        <li className="mb-2">
          Please ensure that the full cheque is clearly visible
        </li>
        <li className="mb-2">
          Supported format: PDF JPG and PNG (max 15MB per file).
        </li>
      </ul>
    </div>
  );

  const getDocumentStatusNode = (status) => {
    if (status === "SUBMITTED") {
      return (
        <div className="note-btn comp-btn w-100">
          <span>
            <IoCheckmarkCircle />
            Submitted
          </span>
        </div>
      );
    } else if (status === "IN_PROGRESS") {
      return (
        <div className="note-btn w-100">
          <span className="text-primary text-nowrap">In Progress</span>
        </div>
      );
    } else if (status === "NOT_STARTED") {
      return (
        <div className="note-btn w-100">
          <span className="text-nowrap">Not Started</span>
        </div>
      );
    } else if (status === "UNDER_REVIEW") {
      return (
        <div className="note-btn w-100">
          <span className="text-nowrap">Under Review</span>
        </div>
      );
    } else if (status === "APPROVED") {
      return (
        <div className="note-btn w-100">
          <span className="text-success text-nowrap">Approved</span>
        </div>
      );
    } else if (status === "REJECTED") {
      return (
        <div className="note-btn w-100">
          <span style={{ fontSize: "16px", color: "#B22D2D" }}>Rejected</span>
        </div>
      );
    } else if (status === "NEEDS_ATTENTION") {
      return (
        <div className="note-btn w-100 ">
          <span style={{ fontSize: "16px" }} className="text-nowrap">Needs Attention</span>
        </div>
      );
    } else {
      return (
        <div className="note-btn w-100">
          <span>Not Started</span>
        </div>
      );
    }
  };

  return (
    <>
      {addDetails && !bankOverview && (
        <div className="company-info-box mt-4">
          {loading || bankLoading ? (
            <div className="" style={{ minHeight: "77vh" }}>
              <Loader />
            </div>
          ) : (
            <div className="container">
              {accountList.length > 0 &&
                accountList.map((account, index) => (
                  <div className="row" key={index}>
                    <div className="col-12">
                      <div className="company-info-inner bank-ac-detail p-3 mb-3">
                        <div className="info-start mb-3 d-flex justify-content-between">
                          <div className="d-flex ">
                            {" "}
                            {getDocumentStatusNode(account?.bankStatus)}
                            {account.isPrimary && (
                              <div className="note-btn w-100 ms-3">
                                <span className="text-primary">Primary</span>
                              </div>
                            )}
                          </div>

                          {account?.bankStatus === "SUBMITTED" ||
                          account?.bankStatus === "NEEDS_ATTENTION" ||
                          account?.bankStatus === "UNDER_REVIEW" ||
                          account?.bankStatus === "REJECTED" ||
                          account?.bankStatus === "APPROVED" ? (
                            <span style={{ cursor: "pointer" }}>
                              <FontAwesomeIcon
                                onClick={() => {
                                  handleEditBankClick(account);
                                  setBankAccount(account);
                                }}
                                icon={faChevronRight}
                                className="ms-2"
                              />
                            </span>
                          ) : (
                            <Button
                              className="d-flex align-items-center"
                              variant="primary"
                              onClick={() => {
                                handleEditBankClick(account);
                                setBankAccount(account);
                              }}
                            >
                              Add Details
                              <span>
                                <LuPlus />
                              </span>
                            </Button>
                          )}
                        </div>

                        <p className="info-title d-flex mb-2 justify-content-between">
                          <span>A/c No.</span>
                          <span className="text-end">{account.accountNum}</span>
                        </p>
                        <p className="info-title mb-2 d-flex justify-content-between">
                          <span>IBAN</span>
                          <span className="text-end">{account.ibanNum}</span>
                        </p>
                        <p className="info-title mb-2 d-flex justify-content-between">
                          <span>Bank name</span>
                          <span className="text-end">{account.bankName}</span>
                        </p>
                        <p className="info-title mb-2 d-flex justify-content-between">
                          <span>Branch</span>
                          <span className="text-end">{account.branchName}</span>
                        </p>
                        <p className="info-title mb-2 d-flex justify-content-between">
                          <span>Swift Code</span>
                          <span className="text-end">{account.swiftCode}</span>
                        </p>
                        <p className="info-title mb-2 d-flex justify-content-between">
                          <span>Currency</span>
                          <span className="text-end">{account.currency}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      )}

      {/* bank overview section */}
      {addDetails && bankOverview && (
        <div className="company-info-box mt-4">
          {bankLoading ? (
            <div className="" style={{ minHeight: "77vh" }}>
              <Loader />
            </div>
          ) : (
            <div className="">
              <div className="container">
                <div className="row">
                  {
                    <div>
                      <div className="col-12">
                        <div className="company-info-inner company-overview-box d-flex align-items-center flex-wrap p-3 mb-3">
                          <div className="info-box align-items-center">
                            <div className="img-box me-3 d-flex align-items-center justify-content-center">
                              <img src={bankImg} style={{ width: 36 }} />
                            </div>
                            <div className="overview-info">
                              <p className="info-title">Bank Details</p>
                            </div>
                          </div>
                          <div className="info-start ms-auto">
                            <span style={{ cursor: "pointer" }}>
                              <FontAwesomeIcon
                                onClick={() => {
                                  if (bankAccountId) {
                                    const selectedAccount = accountList.find(
                                      (acc) => acc.id === bankAccountId,
                                    );
                                    if (selectedAccount) {
                                      handleEditBankClick(selectedAccount);
                                      setShowEditModal(true);
                                    }
                                  }
                                }}
                                icon={faChevronRight}
                                className="ms-2"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="company-info-inner company-overview-box d-flex align-items-center flex-wrap p-3 mb-3">
                          <div className="info-box align-items-center">
                            <div className="img-box me-3 d-flex align-items-center justify-content-center">
                              <img src={SubStepsIcons} style={{ width: 36 }} />
                            </div>
                            <div className="overview-info">
                              <p className="info-title">Bank Statement</p>
                            </div>
                          </div>
                          <div className="info-start ms-auto">
                            {uploadStatus.bankStatement ? (
                              <span style={{ cursor: "pointer" }}>
                                <FontAwesomeIcon
                                  onClick={() => {
                                    setBankAccountId(bankAccountId);
                                    // fetchBankDetail();
                                    setDocumentModal(true);
                                    setType("bankStatement");
                                  }}
                                  icon={faChevronRight}
                                  className="ms-2"
                                />
                              </span>
                            ) : (
                              <Button
                                className="d-flex align-items-center"
                                variant="primary"
                                onClick={() => {
                                  setBankAccountId(bankAccountId);
                                  // fetchBankDetail();
                                  setDocumentModal(true);
                                  setType("bankStatement");
                                }}
                              >
                                Start
                                <span>
                                  <LuPlus />
                                </span>
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="company-info-inner company-overview-box d-flex align-items-center flex-wrap p-3 mb-3">
                          <div className="info-box align-items-center">
                            <div className="img-box me-3 d-flex align-items-center justify-content-center">
                              <img src={ChequeImg} style={{ width: 36 }} />
                            </div>
                            <div className="overview-info">
                              <p className="info-title">Cancelled Cheques</p>
                            </div>
                          </div>
                          <div className="info-start ms-auto">
                            {uploadStatus.cancelledCheque ? (
                              <span style={{ cursor: "pointer" }}>
                                <FontAwesomeIcon
                                  onClick={() => {
                                    setBankAccountId(bankAccountId);
                                    // fetchBankDetail();
                                    setDocumentModal(true);
                                    setType("cancelledCheque");
                                  }}
                                  icon={faChevronRight}
                                  className="ms-2"
                                />
                              </span>
                            ) : (
                              <Button
                                className="d-flex align-items-center"
                                variant="primary"
                                onClick={() => {
                                  setBankAccountId(bankAccountId);
                                  // fetchBankDetail();
                                  setDocumentModal(true);
                                  setType("cancelledCheque");
                                }}
                              >
                                Start
                                <span>
                                  <LuPlus />
                                </span>
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Document Upload Modals */}
      {documentModal && type === "bankStatement" && (
        <DocumentUpload
          setDocumentModal={setDocumentModal}
          type={type}
          documentModal={documentModal}
          uploadedFiles={getUploadedFiles(bankAccountId, type)}
          setUploadedFiles={(files) =>
            setUploadedFilesFor(bankAccountId, type, files)
          }
          handleClose={() => setDocumentModal(false)}
          setUploadSuccess={
            type === "bankStatement"
              ? setBankStatementUploadSucess
              : setChequeUploadSuccess
          }
          guideLinesContent={
            type === "bankStatement"
              ? guidelinesContentBank
              : guidelinesContentCheque
          }
          bankAccountId={bankAccountId}
          title={
            type === "bankStatement"
              ? "Upload Bank Statement - Last 6 Months"
              : "Upload Cancelled Cheque"
          }
          entityId={entityId}
          merchantId={merchantId}
          handleRemoveFile={handleRemoveFile}
          fetchBankDetail={fetchBankDetail}
          loadingModal={editLoadingModal}
        />
      )}

      {documentModal && type === "cancelledCheque" && (
        <DocumentUpload
          setDocumentModal={setDocumentModal}
          documentModal={documentModal}
          type={type}
          uploadedFiles={getUploadedFiles(bankAccountId, type)}
          setUploadedFiles={(files) =>
            setUploadedFilesFor(bankAccountId, type, files)
          }
          handleClose={() => setDocumentModal(false)}
          setUploadSuccess={
            type === "bankStatement"
              ? setBankStatementUploadSucess
              : setChequeUploadSuccess
          }
          guideLinesContent={
            type === "bankStatement"
              ? guidelinesContentBank
              : guidelinesContentCheque
          }
          bankAccountId={bankAccountId}
          title={
            type === "bankStatement"
              ? "Upload Bank Statement - Last 6 Months"
              : "Upload Cancelled Cheque"
          }
          entityId={entityId}
          merchantId={merchantId}
          handleRemoveFile={handleRemoveFile}
          fetchBankDetail={fetchBankDetail}
          loadingModal={editLoadingModal}
        />
      )}

      {/* Edit Bank Modal */}
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        backdrop="static"
        keyboard={false}
        className="company-add-popup"
        centered
      >
        <Modal.Header
          closeButton
          className="d-flex justify-content-between py-3 px-4"
        >
          <Modal.Title>Edit Bank Details</Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleEditSubmit}>
          <Modal.Body className="p-4">
            {editLoadingModal ? (
              <LoaderModal />
            ) : (
              <Row>
                {/* Account Number */}
                <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Bank Account Number</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Account Number"
                    name="accountNum"
                    value={editFormData.accountNum}
                    onChange={handleEditChange}
                    onKeyDown={(e) => {
                      preventAccNum(e);
                    }}
                    isInvalid={
                      editTouched.accountNum && !!editErrors.accountNum
                    }
                  />
                  {editTouched.accountNum && editErrors.accountNum && (
                    <span style={{ color: "red", fontSize: "0.9em" }}>
                      {editErrors.accountNum}
                    </span>
                  )}
                </Form.Group>
                {/* IBAN */}

                <div className="row">
                  {/* IBAN Field */}
                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">
                      IBAN Number
                    </label>
                    <input
                      type="text"
                      className="form-control rounded-3 py-2"
                      placeholder="Enter IBAN"
                      name="ibanNum"
                      value={editFormData.ibanNum || ""}
                      onChange={handleEditChange}
                      onKeyDown={(e) => {
                        preventInvalidSpace(e);
                        preventIBAN(e);
                      }}
                    />
                    {editTouched.ibanNum && editErrors.ibanNum && (
                      <span style={{ color: "red", fontSize: "0.9em" }}>
                        {editErrors.ibanNum}
                      </span>
                    )}
                  </div>

                  <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">
                      Account Currency
                    </label>

                    <div className="position-relative">
                      {/* Search Icon */}
                      <span
                        style={{
                          position: "absolute",
                          left: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#94a3b8",
                          zIndex: 2,
                        }}
                      >
                        <i class="bi bi-search"></i>{" "}
                      </span>

                      <Select
                        options={currencyOptions}
                        value={currencyOptions.find(
                          (option) => option.value === editFormData.currency,
                        )}
                        styles={{
                          ...selectStyles,
                          control: (base, state) => ({
                            ...selectStyles.control(base, state),
                            height: "30px",
                          }),
                        }}
                        placeholder="Select Currency"
                        isSearchable
                        onChange={(selected) =>
                          setEditFormData({
                            ...editFormData,
                            currency: selected?.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                {/* Bank Name */}
                {/* <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Bank Name</Form.Label>
                  <Dropdown
                    onSelect={(eventKey) => {
                      setEditFormData({
                        ...editFormData,
                        bankName: eventKey,
                      });
                      setEditTouched((prev) => ({ ...prev, bankName: true }));
                    }}
                  >
                    <Dropdown.Toggle
                      variant={
                        editFormData.bankName
                          ? "secondary"
                          : "outline-secondary"
                      }
                      id="dropdown-bank"
                      className={
                        editTouched.bankName && editErrors.bankName
                          ? "is-invalid"
                          : ""
                      }
                    >
                      {editFormData.bankName || "Select Bank Name"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      style={{
                        maxHeight: "150px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      {bankList.map((bank, idx) => (
                        <Dropdown.Item key={idx} eventKey={bank}>
                          {bank}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group> */}
                <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Bank Name</Form.Label>
                  <Dropdown
                    onSelect={(eventKey) => {
                      const selectedBank = bankList.find(
                        (bank) => bank.id.toString() === eventKey
                      );
                      setEditFormData({
                        ...editFormData,
                        bankName: selectedBank?.bankName || "",
                        banksId: selectedBank?.id || "",
                      });

                      setEditTouched((prev) => ({
                        ...prev,
                        bankName: true,
                      }));
                    }}
                  >
                    <Dropdown.Toggle
                      variant={
                        editFormData.bankName
                          ? "secondary"
                          : "outline-secondary"
                      }
                      id="dropdown-bank"
                      className={
                        editTouched.bankName &&
                        editErrors.bankName
                          ? "is-invalid"
                          : ""
                      }
                    >
                      {editFormData.bankName || "Select Bank Name"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{
                        maxHeight: "150px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      {bankList.map((bank) => (
                        <Dropdown.Item
                          key={bank.id}
                          eventKey={bank.id.toString()}
                        >
                          {bank.bankName}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                {/* Branch Name */}
                <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Branch Name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Branch Name"
                    name="branchName"
                    value={editFormData.branchName}
                    onChange={handleEditChange}
                    onKeyDown={preventEdgeSpace}
                    isInvalid={
                      editTouched.branchName && !!editErrors.branchName
                    }
                  />
                  {editTouched.branchName && editErrors.branchName && (
                    <span style={{ color: "red", fontSize: "0.9em" }}>
                      {editErrors.branchName}
                    </span>
                  )}
                </Form.Group>
                {/* SWIFT Code */}
                <Form.Group as={Col} md="12" className="mb-4">
                  <Form.Label>Swift Code</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter swift code"
                    name="swiftCode"
                    value={editFormData.swiftCode}
                    onChange={handleEditChange}
                    onKeyDown={(e) => {
                      preventSwiftCode(e);
                    }}
                    isInvalid={editTouched.swiftCode && !!editErrors.swiftCode}
                  />
                  {editTouched.swiftCode && editErrors.swiftCode && (
                    <span style={{ color: "red", fontSize: "0.9em" }}>
                      {editErrors.swiftCode}
                    </span>
                  )}
                </Form.Group>
                <div className="col-12 ">
                  {/* Toggle Switch */}
                  <div className="  form-switch d-flex align-items-center mb-2 ">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="primaryAccountSwitch"
                      name="isPrimary"
                      checked={editFormData.isPrimary}
                      onChange={handleEditChange}
                      style={{
                        width: "2.5em",
                        cursor: "pointer",
                      }}
                    />

                    <label
                      htmlFor="primaryAccountSwitch"
                      className="ms-2 mt-1 fs-6" // style={{
                    >
                      Mark this as Primary Account
                    </label>
                  </div>

                  <p
                    className="text-secondary small mb-0"
                    style={{ fontSize: "0.875rem" }}
                  >
                    When toggled on, this account will replace any previously
                    selected primary account for your company.
                  </p>
                </div>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer className="p-3 border-0 btn-save">
            <Button
              variant={editAllValid ? "primary active" : "primary"}
              disabled={!editAllValid}
              className="btn-save"
              type="submit"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default BankAccountsList;
